const MICROSERVICES = {
HEATLOANMANAGER:'heatloan-mgr'
}

export {
  MICROSERVICES
}